module.exports = __webpack_public_path__ + "fonts/fa-solid-900.6661d6b3.woff";